import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import { LocationSearchBox } from '../common/locationSearchBox.js';
import { makeSearchURL } from '../common/searchRequestUtils.js';
import * as MapSearchUtils from './MapSearchUtils.js';


const DEFAULT_SEARCH_URL = baseURL + 'donors/search.html';

export const AskForLocationPrompt = function ({ processInitialRenderAndSearch }) {
    const locationSearchBoxRef = useRef(null);
    const [allowLocationSearchSubmit, setAllowLocationSearchSubmit] = useState(false);

    const submitLocationSearch = function () {
        if (allowLocationSearchSubmit) {
            locationSearchBoxRef.current.submit();
        }
    };

    const performInitialSearch = function(locationSearchUrl) {
        const newSearchParams = getURLParams(locationSearchUrl);
        if ((!newSearchParams.centerLat || !newSearchParams.centerLng) && newSearchParams.state) {
            const searchParamsForState = MapSearchUtils.Helpers.getDefaultLatLngForStateCode(newSearchParams.state);
            if (searchParamsForState) {
                newSearchParams.centerLat = searchParamsForState.lat;
                newSearchParams.centerLng = searchParamsForState.lng;
            }
        }
        if (!newSearchParams.centerLat || !newSearchParams.centerLng) {
            const defaultSearchParams = MapSearchUtils.Helpers.getDefaultStartingLatLngBasedOnSystemTime();
            newSearchParams.centerLat = defaultSearchParams.lat;
            newSearchParams.centerLng = defaultSearchParams.lng;
        }
        return processInitialRenderAndSearch(Number(newSearchParams.centerLat), Number(newSearchParams.centerLng), null)
    };

    const locationSearchBoxCallbacks = {
        changeURL: performInitialSearch,
        makeSearchURL: makeSearchURL,
        setAllowLocationSearchSubmit: setAllowLocationSearchSubmit,
    };

    return (
        <div className='location-prompt'>
            <div className="location-prompt-container">
                <h3>Support a local school</h3>
                <p>Enter a location to see schools</p>
                <div className='links form-redux'>
                    <LocationSearchBox
                        searchURL= {DEFAULT_SEARCH_URL}
                        callbacks = {locationSearchBoxCallbacks}
                        ref = {locationSearchBoxRef}
                        directlyUpdateText = {true}
                    />
                    <button className='button-primary' type='button' disabled={!allowLocationSearchSubmit} onClick={() => submitLocationSearch()}>Search</button>
                </div>
            </div>
            <div className='premap'></div>
        </div>
    );
};

AskForLocationPrompt.propTypes = {
    processInitialRenderAndSearch: PropTypes.func.isRequired,
};
